module.exports = __webpack_public_path__ + "img/KURGAN.faeb3c71.png";